export default __webpack_public_path__ + "up-arrow.png";